import { useState } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { getTheme } from '../../../publicSession/selectors';
import { ThemeOptions } from '@wix/da-react-context/pkg/constants';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink/PlainButtonOrLink';
import { useTranslation } from 'react-i18next';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';

import s from './ThemeToggle.scss';

export default ({ className, toggleTheme }) => {
  const theme = useSelector(getTheme);
  const [currentTheme, setCurrentTheme] = useState(theme);
  const { t } = useTranslation();

  return (
    <PlainButtonOrLink
      aria-label={t('siteHeader.userMenu.themeDark')}
      aria-pressed={theme === ThemeOptions.DARK}
      tabIndex={0}
      onClick={() => {
        setCurrentTheme(
          theme === ThemeOptions.LIGHT ? ThemeOptions.DARK : ThemeOptions.LIGHT
        );
        yieldToMain(toggleTheme);
      }}
    >
      <div
        className={classnames(
          s['root'],
          currentTheme === ThemeOptions.LIGHT && s['day'],
          className
        )}
      >
        <label className={s['toggle']} htmlFor="checkbox">
          <i className={s['star']} />
          <i className={s['star']} />
          <i className={s['star']}>
            <span className={s['star-trail']} />
          </i>
          <i className={s['star']} />
          <span className={s['disc']}>
            <i />
          </span>
          <span className={classnames(s['cloud'], s['cloud1'])} />
          <span className={classnames(s['cloud'], s['cloud2'])} />
        </label>
      </div>
    </PlainButtonOrLink>
  );
};
